import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const wasteWaterTreatmentPlantListItemSchema = baseAssetWithTimeseriesSchema.extend({
  name: z.string(),
});

export type WasteWaterTreatmentPlantListItem = z.infer<
  typeof wasteWaterTreatmentPlantListItemSchema
>;

export const wasteWaterTreatmentPlantListSchema = paginatedSchema(
  wasteWaterTreatmentPlantListItemSchema
);
export type WasteWaterTreatmentPlantList = z.infer<typeof wasteWaterTreatmentPlantListSchema>;

export const wasteWaterTreatmentPlantSchema = wasteWaterTreatmentPlantListItemSchema;
export type WasteWaterTreatmentPlant = z.infer<typeof wasteWaterTreatmentPlantSchema>;

export function useWasteWaterTreatmentPlants(params = {}) {
  const url = combineUrlAndParams("/api/v4/wastewatertreatmentplants/", params);
  return useParsedQuery<WasteWaterTreatmentPlantList>(
    ["lizard-api-v4", "wastewatertreatmentplants", url],
    () => fetchWithError(url),
    (json: unknown) => wasteWaterTreatmentPlantListSchema.parse(json)
  );
}

export function useWasteWaterTreatmentPlant(id: number) {
  return useParsedQuery<WasteWaterTreatmentPlant>(
    ["lizard-api-v4", "wastewatertreatmentplants", id],
    () => fetchWithError(`/api/v4/wastewatertreatmentplants/${id}/`),
    (json: unknown) => wasteWaterTreatmentPlantSchema.parse(json)
  );
}

export function useMultipleWasteWaterTreatmentPlants(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "wastewatertreatmentplants", id],
        fetchFunction: () => fetchWithError(`/api/v4/wastewatertreatmentplants/${id}/`),
        parseFunction: (json: unknown) => wasteWaterTreatmentPlantSchema.parse(json),
      };
    })
  );
}
